export const CFullWidthVideoFragments = {
  field: `
    fragment fullWidthVideo on fullWidthVideo_MatrixField {
      ... on fullWidthVideo_block_Entry {
        id
        typeHandle
        idName
        desktopPoster: poster {
          url @transform(mode: "crop", width: 2000, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        mobilePoster: poster {
          url @transform(mode: "crop", width: 640, immediately: true)
          title
          hasFocalPoint
          focalPoint
        }
        video {
          url
          title
          embeddedAsset {
            url
            title
          }
        }
        longVideo {
          url
          title
          embeddedAsset {
            url
            title
          }
        }
        videoOrientation
        position
      }
    }
  `,
}
